export default {"src":"/_next/static/media/ic-select-blue.2ccbbfa3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};